module.exports = __webpack_public_path__ + "img/e.21b7e688.jpg";